if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        let cart = null;
        try {
          cart = await this.getReadyCart();
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (cart) {
            formData.append(
              'sections',
              cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          const result = await fetch(`${routes.cart_add_url}`, config);
          const response = await result.json();
          if (!result.ok || response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
            });
            this.handleErrorMessage(response.description || response.message || window.cartStrings.error);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure('add:paint-updated-sections', () => {
                    cart.renderContents(response);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure('add:paint-updated-sections', () => {
              cart.renderContents(response);
            });
          }
        } catch (error) {
          console.error(error);
          this.error = true;
          this.handleErrorMessage(window.cartStrings?.error || 'Something went wrong. Please try again.');
        } finally {
          this.submitButton.classList.remove('loading');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          if (!this.submitButton.hasAttribute('disabled')) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          CartPerformance.measureFromEvent('add:user-action', evt);
        }
      }

      async getReadyCart() {
        if (typeof window.ushoreGetReadyCart === 'function') {
          return window.ushoreGetReadyCart();
        }

        if (!this.cart) return null;

        if (this.cartIsReady(this.cart)) return this.cart;

        if (typeof window.ushoreLoadCartDrawerScripts === 'function') {
          try {
            await window.ushoreLoadCartDrawerScripts();
          } catch (error) {
            console.error(error);
          }
        }

        return this.cartIsReady(this.cart) ? this.cart : null;
      }

      cartIsReady(cart) {
        return (
          typeof cart.getSectionsToRender === 'function' &&
          typeof cart.setActiveElement === 'function' &&
          typeof cart.renderContents === 'function'
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
